import { useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PostFinanceAddinfoAccountsService } from "@/features/accounts/finance/services/post-addinfo-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useGetFinanceAccount } from "@/features/accounts/finance/hooks/use-get-accounts";
import { AccountsInfo } from "@/features/accounts/shared/hooks/use-select-accounts";


export const usePostFinanceAddinfoAccounts = () => {
  const { getFinanceAccounts } = useGetFinanceAccount();
  const { setError } = useContext(ErrorDialogContext);
  const loadingCtx = useContext(LoadingModalContext);

  const postFinanceAddinfoAccountsService = new PostFinanceAddinfoAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関登録
  const registerFinanceAddinfoAccounts = async (
    accountGroupId: string,
    financeAccountId: string,
    accountTypeCode: string,
    branchNumber: string,
    financeNumber: string,
  ): Promise<AccountsInfo[] | undefined> => {
    loadingCtx.setIsLoading(true);
    try {
      const post_res = await postFinanceAddinfoAccountsService.postFinanceAddinfoAccounts({
        account_group_id: accountGroupId,
        finance_account_id: financeAccountId,
        account_type_code: accountTypeCode,
        branch_number: branchNumber,
        finance_number: financeNumber,
      });
      if (!post_res) {
        throw new Error("金融機関の登録に失敗しました。");
      }
      const get_res = await getFinanceAccounts(accountGroupId, financeAccountId);
      // エラー時（undefined）は処理を中断
      if (get_res === undefined) {
        return undefined;
      }
      const resAccounts: AccountsInfo[] = get_res.flatMap(financeAccount => 
        financeAccount.finance_list
        .filter(finance => finance.finance_type_code === 1 || finance.finance_type_code === 2) // 普通・当座のみ
        .map(finance => ({
          accountGroupId: accountGroupId,
          mlinkAccountId: financeAccount.finance_account_id,
          mlinkId: finance.finance_id,
          accountKindName: finance.account_display_name,
          accountNo: finance.finance_number,
          selectedStatus: finance.selected_status,
          passbookType: financeAccount.industry_code,
          userInputName: "",
          scrapeType: 0,
          otpYn: "0",
        }))
      );
      return resAccounts;
    } catch (error) {
      // エラーハンドリング
      console.log("registerFinanceAddinfoAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    registerFinanceAddinfoAccounts: errorHandledAsync(registerFinanceAddinfoAccounts, setError),
  };
};
